<script>
	export let id;
	export let label;
	export let name;
	export let required = false;
	export let files;
</script>

<label for={id}>{label}</label>
<input bind:files {id} {name} {required} type="file">